import { api } from "./configs/axiosConfigs"

export const UserAPI = {
    getUsers: async (data: any) => {
        const response = await api.get(
            '/user', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    getUsersByCompany: async (data: any) => {
        const response = await api.get(
            '/user/listByCompany', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    createUser: async (data: any) => {
        const response = await api.post(
            '/user/register', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    createUserBySuperadmin: async (data: any) => {
        const response = await api.post(
            '/user/registerBySuperadmin', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    editUser: async (iduser: number, data: any) => {
        const response = await api.patch(
            `/user/${iduser}`, data
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    deleteUser: async (iduser: number) => {
        const response = await api.delete(
            `/user/${iduser}`
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    verifyPIN: async (data: any) => {
        const response = await api.post(
            '/user/verify-pin', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    changePassword: async (data: object) => {
        const response = await api.post(
            '/user/changePassword', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    forgotPassword: async (data: object) => {
        const response = await api.post(
            '/user/forgotPassword', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },
}